import React,
{
    useState
}
from "react";

import AssessmentQuestion
    from "./AssessmentQuestion";

export default function BuildingBookAssetCompliance()
{
	const options =
	[
	    {
	        label: "PASS",
	        gradient: "linear-gradient(180deg,#2fa56f 0%,#15803d 100%)"
	    },
	    {
	        label: "FAIL",
	        gradient: "linear-gradient(180deg,#e05252 0%,#b91c1c 100%)"
	    },
	    {
	        label: "N/A",
	        gradient: "linear-gradient(180deg,#e6a21a 0%,#b45309 100%)"
	    }
	];

    const [fire,
        setFire] =
            useState("PASS");

    const [pat,
        setPat] =
            useState("PASS");

    const [legionella,
        setLegionella] =
            useState("FAIL");

    const [risk,
        setRisk] =
            useState("PASS");

    return (

        <div>

            <h2>
                Compliance Assessment
            </h2>

            <AssessmentQuestion
                title="Fire Inspection"
                value={fire}
                options={options}
                setValue={setFire}
            />

            <AssessmentQuestion
                title="PAT Test"
                value={pat}
                options={options}
                setValue={setPat}
            />

            <AssessmentQuestion
                title="Legionella"
                value={legionella}
                options={options}
                setValue={setLegionella}
            />

            <AssessmentQuestion
                title="Risk Assessment"
                value={risk}
                options={options}
                setValue={setRisk}
            />

        </div>

    );
}